/* Games Mat V2 — gallery + variant/price behavior.
   Vanilla JS, no theme dependencies. Safe to load on any page:
   every hook is feature-detected before use. */
(function () {
  'use strict';

  function formatMoney(cents, template) {
    // Minimal money formatter using the shop's money format template.
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var replacements = {
      '{{amount}}': whole + '.' + parts[1],
      '{{amount_no_decimals}}': whole,
      '{{amount_with_comma_separator}}': parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1],
      '{{amount_no_decimals_with_comma_separator}}': parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    };
    var out = template || '${{amount}}';
    Object.keys(replacements).forEach(function (key) {
      out = out.replace(key, replacements[key]);
    });
    return out;
  }

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-gmv2-thumb]');
    var medias = root.querySelectorAll('[data-gmv2-media]');
    if (!thumbs.length || !medias.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-gmv2-thumb');
        medias.forEach(function (m) {
          m.classList.toggle('is-active', m.getAttribute('data-gmv2-media') === id);
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  function initVariants(root) {
    var select = root.querySelector('[data-gmv2-variant-select]');
    var dataEl = root.querySelector('[data-gmv2-product-json]');
    if (!select || !dataEl) return;

    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var moneyFormat = dataEl.getAttribute('data-money-format') || '${{amount}}';
    var idInput = root.querySelector('[data-gmv2-variant-id]');
    var btn = root.querySelector('[data-gmv2-atc]');
    var btnLabel = btn ? (btn.getAttribute('data-label-add') || btn.textContent) : '';
    var soldOutLabel = btn ? (btn.getAttribute('data-label-sold-out') || 'Sold out') : '';

    // Price nodes can exist in several sections (hero + final offer).
    var priceNews = document.querySelectorAll('[data-gmv2-price]');
    var priceOlds = document.querySelectorAll('[data-gmv2-compare-price]');
    var saves = document.querySelectorAll('[data-gmv2-save]');

    select.addEventListener('change', function () {
      var variant = product.variants.filter(function (v) {
        return String(v.id) === select.value;
      })[0];
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      priceNews.forEach(function (el) {
        el.textContent = formatMoney(variant.price, moneyFormat);
      });

      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceOlds.forEach(function (el) {
        el.classList.toggle('is-hidden', !hasCompare);
        if (hasCompare) el.textContent = formatMoney(variant.compare_at_price, moneyFormat);
      });
      saves.forEach(function (el) {
        el.classList.toggle('is-hidden', !hasCompare);
        if (hasCompare) {
          el.textContent = 'SAVE ' + formatMoney(variant.compare_at_price - variant.price, moneyFormat).replace(/\.00($|\b)/, '');
        }
      });

      if (btn) {
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? btnLabel : soldOutLabel;
      }

      // Jump gallery to the variant's image when it has one.
      if (variant.featured_media) {
        var thumb = root.querySelector('[data-gmv2-thumb="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
    });
  }

  function initScrollCtas() {
    document.querySelectorAll('a[href="#gmv2-buy"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById('gmv2-buy');
        if (!target) return;
        e.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-gmv2-hero]').forEach(function (root) {
      initGallery(root);
      initVariants(root);
    });
    initScrollCtas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
